import { supabase } from "@/lib/supabase";

export type AdminUserRole = "admin" | "editor" | "reader";

type Action =
  | { action: "create"; email: string; password: string; name?: string; role?: AdminUserRole }
  | { action: "delete"; user_id: string }
  | { action: "update_role"; user_id: string; role: AdminUserRole }
  | { action: "reset_password"; email: string };

async function callAdminUsers<T = unknown>(payload: Action): Promise<T> {
  if (!supabase) throw new Error("Supabase no configurado");
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error("No autenticado");

  const url = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/admin-users`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${session.access_token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.error || `Error ${res.status}`);
  return json as T;
}

export function adminCreateUser(input: {
  email: string;
  password: string;
  name?: string;
  role?: AdminUserRole;
}) {
  return callAdminUsers<{ id: string; email: string; role: AdminUserRole }>({
    action: "create",
    ...input,
  });
}

export function adminDeleteUser(user_id: string) {
  return callAdminUsers<{ ok: true }>({ action: "delete", user_id });
}

export function adminUpdateUserRole(user_id: string, role: AdminUserRole) {
  return callAdminUsers<{ ok: true }>({ action: "update_role", user_id, role });
}

export function adminResetPassword(email: string) {
  return callAdminUsers<{ ok: true }>({ action: "reset_password", email });
}
